"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackgroundImageSrc = exports.getBackgroundImageStyleAttribute = void 0;
const react_1 = __importStar(require("react"));
const head_1 = __importDefault(require("next/head"));
const classnames_1 = __importDefault(require("classnames"));
const Responsive_1 = require("../Responsive");
const ConditionalWrapper_1 = __importDefault(require("../ConditionalWrapper"));
const styles = require('./BackgroundImageContainer.module.scss');
const getBackgroundImageNameSrc = ({ backgroundImageName, isSmall, }) => `/static-assets/images/sections/${backgroundImageName}${isSmall ? '?resize=800' : ''}`;
const getBackgroundImageUrlSrc = ({ backgroundImageUrl, isSmall, }) => (backgroundImageUrl ? `${backgroundImageUrl}?fm=webp${isSmall ? '&w=800' : ''}` : undefined);
const getBackgroundImageStyleAttribute = (backgroundImageSrc) => {
    if (backgroundImageSrc) {
        return {
            style: {
                backgroundImage: `url(${backgroundImageSrc})`,
            },
        };
    }
    return {};
};
exports.getBackgroundImageStyleAttribute = getBackgroundImageStyleAttribute;
const getBackgroundImageSrc = ({ backgroundImageName, backgroundImageUrl, fallbackImageName, isLoadingBackgroundImage, isSmall, }) => {
    if (backgroundImageUrl) {
        return getBackgroundImageUrlSrc({ backgroundImageUrl, isSmall });
    }
    if (backgroundImageName) {
        return getBackgroundImageNameSrc({
            backgroundImageName,
            isSmall,
        });
    }
    if (fallbackImageName && !isLoadingBackgroundImage) {
        return getBackgroundImageNameSrc({
            backgroundImageName: fallbackImageName,
            isSmall,
        });
    }
    return undefined;
};
exports.getBackgroundImageSrc = getBackgroundImageSrc;
const BackgroundImageContainer = ({ backgroundGradient, backgroundImageName, backgroundImageUrl, children, classes: { root: rootClassName, background: backgroundClassName } = { root: '', background: '' }, fallbackImageName, hasAngledBackground, isLoadingBackgroundImage, preloadBackgroundImage = true, }) => {
    const isBelowMedium = (0, Responsive_1.useResponsive)({ maxWidth: 'medium' });
    const backgroundImageSrc = (0, react_1.useMemo)(() => (0, exports.getBackgroundImageSrc)({
        backgroundImageName,
        backgroundImageUrl,
        fallbackImageName,
        isSmall: isBelowMedium,
        isLoadingBackgroundImage,
    }), [
        backgroundImageName,
        backgroundImageUrl,
        fallbackImageName,
        isBelowMedium,
        isLoadingBackgroundImage,
    ]);
    const hasBackgroundImage = !!backgroundImageSrc;
    const hasBackgroundGradient = !!backgroundGradient || !!backgroundClassName;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hasBackgroundImage && preloadBackgroundImage && (react_1.default.createElement(head_1.default, null,
            react_1.default.createElement("link", { rel: "preload", as: "image", href: backgroundImageName
                    ? getBackgroundImageNameSrc({
                        backgroundImageName,
                        isSmall: isBelowMedium,
                    })
                    : getBackgroundImageUrlSrc({ backgroundImageUrl, isSmall: isBelowMedium }) }))),
        react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)({
                [styles.backgroundImage]: hasBackgroundImage,
                [styles.angledBackground]: !!hasAngledBackground,
                [rootClassName]: !!rootClassName,
            }) }, (0, exports.getBackgroundImageStyleAttribute)(backgroundImageSrc)),
            react_1.default.createElement(ConditionalWrapper_1.default, { condition: hasBackgroundGradient, wrapper: (backgroundGradientChildren) => (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                        [styles.backgroundOpacityMedium]: backgroundGradient === 'medium',
                        [styles.backgroundOpacityDark]: backgroundGradient === 'dark',
                        [backgroundClassName]: !!backgroundClassName,
                    }) }, backgroundGradientChildren)) }, children))));
};
exports.default = (0, react_1.memo)(BackgroundImageContainer);
//# sourceMappingURL=BackgroundImageContainer.js.map